<template>
	<div class="servicesnav">
		<ul class="servicesnav__list" v-scroll-spy-active v-scroll-spy-link>
			<li data-section-selector="#process__research" class="servicesnav__items">
				<a>
					<span class="servicesnav__text--step">Step 1</span>
					<span class="servicesnav__text--process">Research</span>
				</a>
			</li>
			<li data-section-selector="#process__design" class="servicesnav__items">
				<a>
					<span class="servicesnav__text--step">Step 2</span>
					<span class="servicesnav__text--process">Design</span>
				</a>
			</li>
			<li
				data-section-selector="#process__development"
				class="servicesnav__items"
			>
				<a>
					<span class="servicesnav__text--step">Step 3</span>
					<span class="servicesnav__text--process">Prototyping</span>
				</a>
			</li>
			<li data-section-selector="#process__testing" class="servicesnav__items">
				<a>
					<span class="servicesnav__text--step">Step 4</span>
					<span class="servicesnav__text--process">Testing</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./ServicesSideNav.scss";
</style>